// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".graduate-tips-slider .vueperslides__bullets{bottom:-1.2rem;height:1rem;position:absolute;z-index:1}.graduate-tips-slider .vueperslides__bullet{margin:1rem .3rem}.graduate-tips-slider .vueperslides__bullet .default{background-color:#455fed;border:none;box-shadow:none;height:.4rem;width:.4rem}.graduate-tips-slider .vueperslides__bullet--active .default{background-color:#455fed;border:none;height:.87rem;width:.87rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
